<ng-container *transloco="let convert;">
  <section data-test-id="address-change-drawer-container" class="ui-drawer" [ngClass]="{ 'is-open': open }">
    <button
      data-test-id="address-change-drawer-close-btn"
      data-track-elem="icon"
      data-track-name="Close"
      data-track-trigger="close"
      class="drawer__close"
      [attr.aria-label]="convert('common.btnClose')"
      (click)="cancel(); addressChangeForm.resetForm()"
      >
      <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
    </button>
    <div class="fields col-sm-12 col-md-6 col-lg-8">
      <h3 data-test-id="address-change-drawer-header" [innerHTML]="convert('profileManagement.addressChangeDrawer.textRequestAdd', {variant : variant})"></h3>
      <p data-test-id="address-change-drawer-description">
        @if (isPhysical) {
          {{convert('profileManagement.addressChangeDrawer.textUpdatePhysical')}}
        }
        @if (isTitle) {
          {{convert('profileManagement.addressChangeDrawer.textUpdateTitle')}}
        }
      </p>
      <app-address-change-form
        data-test-id="address-change-drawer-form"
        [variant]="variant"
        (closed)="cancel()"
        (updated)="success.emit();"
        (sendError)="receiveError($event)"
        #addressChangeForm
      ></app-address-change-form>
    </div>
  </section>
</ng-container>
